import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
import toggler from './jquery/toggler';

const routes = [
  {
    path: "",
    component: () => import("./views/highlow"),
    children: [
      { path: '/', component: () => import("./views/highlow/Home") },
      { path: '/overview', component: () => import("./views/highlow/Overview") },
      { path: '/why-trade', component: () => import("./views/highlow/WhyTrade") },
      { path: '/terms-of-service', component: () => import("./views/highlow/Term") },
      { path: '/privacy-policy', component: () => import("./views/highlow/policy") },
      { path: '/about-company', component: () => import("./views/highlow/Company1"), meta: { name: 'robots', content: 'noindex' }},
      { path: '/banking', component: () => import("./views/highlow/Banking") },
      { path: '/points', component: () => import("./views/highlow/Points") },
      { path: '/company', component: () => import("./views/highlow/Company") },
      { path: '/faq', component: () => import("./views/highlow/qa") },
      { path: '/demo', component: () => import("./views/highlow/demo") },

      { path: '/affiliate', component: () => import("./views/highlow/affiliate") },
      { path: '/contact-us', component: () => import("./views/highlow/contactUs") },
      { path: '/help-and-support', component: () => import("./views/highlow/HelpAndSupport") },
      {
        path: "/trade",
        name: "trade",
        component: () => import("./views/trade"),
        redirect: "/trading-platforms",
        children: [
          { path: '/trade/option-types', component: () => import("./views/trade/OptionTypes") },
          { path: '/trade/options-schedule', component: () => import("./views/trade/OptionsSchedule") },
          { path: '/trade/trading-platforms', component: () => import("./views/trade/TradingPlatform") },
          { path: '/trade/trade-conditions', component: () => import("./views/trade/TradeConditions") },
        ]
      },
      {
        path: "/resources",
        name: "resources",
        component: () => import("./views/resources"),
        redirect: "/resources/overview",
        children: [
          { path: '/resources/overview', component: () => import("./views/resources/Overview") },
          { name: 'faq', path: '/resources/faq', component: () => import("./views/resources/Faq"), props: (route) => ({ query: route.query.q }) },
        ]
      },
      {
        path: "/user",
        name: "user",
        component: () => import("./views/user"),
        children: [
          { path: '/user/overview', component: () => import("./views/resources/Overview") },
        ]
      },
    ]
  },
  {
    path: "/error",
    component: () => import("./views/Error"),
    visible: false
  },
  {
    path: "*",
    component: () => import("./views/Error"),
    visible: false
  }
];


const router = new VueRouter({
  base: process.env.BASE_URL,
  linkActiveClass: "active",
  mode: "hash",
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      // savedPosition is only available for popstate navigations.
      return savedPosition
    } else {
      const position = {x:0, y:0}
  
      // scroll to anchor by returning the selector
      if (to.hash) {
        position.selector = to.hash
  
        // bypass #1number check
        if (/^#\d/.test(to.hash) || document.querySelector(to.hash)) {
          return position
        }
  
        // if the returned position is falsy or an empty object,
        // will retain current scroll position.
        return false
      }
  
      return new Promise(resolve => {
        // check if any matched route config has meta that requires scrolling to top
        if (to.matched.some(m => m.meta.scrollToTop)) {
          // coords will be used if no selector is provided,
          // or if the selector didn't match any element.
          position.x = 0
          position.y = 0
        }
        resolve(position)
      })
    }
  }
});

router.afterEach(to => {
  if (to.meta.name) {
    var meta = document.createElement('meta');
    meta.setAttribute('name', to.meta.name);
    meta.setAttribute('content', to.meta.content);
    document.head.insertAdjacentElement('afterbegin', meta);
  }
});

var $ = require('jquery')
var imagesLoaded = require('imagesloaded');

router.beforeEach((to, form, next) => {
  $("body").removeClass("mti-active")
  next()
});

router.afterEach((to, from) => {
  console.log(from)
  console.log(to.query)
  router.app.$nextTick(function () {
    toggler.init();
    setTimeout(function () {
      // Pass the component definition to the resolve callback
      $("body").addClass("mti-active")
    }, 100)

    $(".p-image-container-fade-in").each(function () {
      var a = $(this);
      imagesLoaded(a, function () {
        a.addClass("images-loaded")
      })
    })

    var a = $(".illustrations");
    a.length > 0 && imagesLoaded(a, function () {
      a.addClass("loaded")
    });
      
  })
})

export default router;
